import { PAGE_TYPE } from '@amzn/journeys-common';
import { REF_TAG_REGEX } from './constants';

/**
 * Sanitizes a reference tag by applying transformations in specific order
 *
 * @param refTag - The reference tag to sanitize
 * @returns The sanitized reference tag
 *
 * Transformations applied:
 * 1. Removes invalid characters (keeps only alphanumeric, underscore, hyphen)
 * 2. Removes trailing non-alphanumeric characters
 * 3. Replaces consecutive punctuation (__ -> _, -- -> -)
 */
export const sanitizeRefTag = (refTag: string): string =>
  refTag
    .replaceAll(REF_TAG_REGEX.INVALID_CHARACTERS, '')
    .replaceAll(REF_TAG_REGEX.ENDS_WITH_NON_ALPHA, '')
    .replaceAll(REF_TAG_REGEX.CONSECUTIVE_PUNCTUATION, (match) => (match.includes('_') ? '_' : '-'));

/**
 * Generates a reference tag based on the creative name
 *
 * @param creativeName - The name of the creative
 * @param pageType - Optional page type to determine prefix behavior
 * @returns The generated and sanitized reference tag. For EVENTS page type, returns the creative name without prefix. For all other page types (or undefined), returns 'ods_gw_' prefixed creative name.
 */
export const generateRefTag = (creativeName: string, pageType?: PAGE_TYPE): string => {
  if (!creativeName) return '';

  const rawRefTag = pageType === PAGE_TYPE.EVENTS ? creativeName : `ods_gw_${creativeName}`;
  return sanitizeRefTag(rawRefTag);
};
